<div class="twin-links" alAnchor="agent.linked-tutors-list">
  <header class="tile-flat__header">
    <p class="tile__hint">
      {{
        (isClientWide ? 'tutor.twinLinks.hintAdmin' : 'tutor.twinLinks.hintUser')
          | translate
      }}
    </p>
  </header>

  <!-- Currently linked tutors -->
  <ul class="linked-list" *ngIf="linkedTutors.length; else noneLinked">
    <li *ngFor="let t of linkedTutors" class="linked-row">
      <span class="linked-row__name">{{ t.name }}</span>
      <span class="linked-row__tpl">
        {{ templateLabelKey(t.template_name) | translate }}
      </span>
      <button
        *ngIf="isClientWide"
        nbButton
        ghost
        status="danger"
        size="tiny"
        class="linked-row__detach"
        [disabled]="loading"
        (click)="detach(t)"
      >
        <nb-icon icon="unlink-outline"></nb-icon>
        {{ 'tutor.twinLinks.detach' | translate }}
      </button>
    </li>
  </ul>
  <ng-template #noneLinked>
    <p class="twin-links__empty">{{ 'tutor.twinLinks.none' | translate }}</p>
  </ng-template>

  <!-- Admin / manager: direct attach -->
  <ng-container *ngIf="isClientWide">
    <button
      *ngIf="!attachOpen"
      nbButton
      status="primary"
      size="small"
      class="twin-links__cta"
      alAnchor="agent.twin-attach"
      [disabled]="!availableTargets.length"
      (click)="toggleAttach()"
    >
      <nb-icon icon="plus-outline"></nb-icon>
      {{ 'tutor.twinLinks.attachCta' | translate }}
    </button>
    <p
      *ngIf="!availableTargets.length && !attachOpen"
      class="twin-links__empty"
    >
      {{ 'tutor.twinLinks.noTargets' | translate }}
    </p>

    <div class="edit-panel" *ngIf="attachOpen">
      <nb-select
        class="target-select"
        alAnchor="agent.twin-attach-select"
        placeholder="{{ 'tutor.twinLinks.selectTutor' | translate }}"
        [(selected)]="attachTargetId"
        fullWidth
      >
        <nb-option *ngFor="let t of availableTargets" [value]="t.id">
          <span class="tutor-opt">
            <span class="tutor-opt__name">{{ t.name }}</span>
            <small *ngIf="t.linked_to_other_twin" class="tutor-opt__badge">
              {{ 'tutor.twinLinks.linkedElsewhere' | translate }}
            </small>
          </span>
        </nb-option>
      </nb-select>
      <div class="panel-actions">
        <button nbButton ghost size="small" (click)="toggleAttach()">
          {{ 'buttons.cancel' | translate }}
        </button>
        <button
          nbButton
          status="primary"
          size="small"
          [disabled]="!attachTargetId || loading"
          alAnchor="agent.twin-attach-confirm"
          (click)="confirmAttach()"
        >
          {{ 'tutor.twinLinks.attach' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Rights-limited dozent: request a link -->
  <ng-container *ngIf="!isClientWide">
    <ul class="req-list" *ngIf="visibleRequests.length">
      <li
        *ngFor="let r of visibleRequests"
        class="req-row"
        [attr.data-status]="r.status"
      >
        <span class="req-row__target">{{ r.target_tutor_name }}</span>
        <span class="req-row__status" [attr.data-status]="r.status">
          {{ statusKey(r.status) | translate }}
        </span>
        <span *ngIf="r.decision_note" class="req-row__note">{{
          r.decision_note
        }}</span>
      </li>
    </ul>

    <button
      *ngIf="!requestOpen"
      nbButton
      status="primary"
      size="small"
      class="twin-links__cta"
      [disabled]="!requestableTargets.length"
      (click)="toggleRequest()"
    >
      <nb-icon icon="paper-plane-outline"></nb-icon>
      {{ 'tutor.twinLinks.requestCta' | translate }}
    </button>
    <p
      *ngIf="!requestableTargets.length && !requestOpen"
      class="twin-links__empty"
    >
      {{ 'tutor.twinLinks.noRequestTargets' | translate }}
    </p>

    <div class="edit-panel" *ngIf="requestOpen">
      <label class="field-label">
        {{ 'tutor.twinLinks.selectTutor' | translate }}
      </label>
      <nb-select
        class="target-select"
        placeholder="{{ 'tutor.twinLinks.selectTutor' | translate }}"
        [(selected)]="requestTargetId"
        fullWidth
      >
        <nb-option *ngFor="let t of requestableTargets" [value]="t.id">
          <span class="tutor-opt">
            <span class="tutor-opt__name">{{ t.name }}</span>
            <small *ngIf="t.linked_to_other_twin" class="tutor-opt__badge">
              {{ 'tutor.twinLinks.linkedElsewhere' | translate }}
            </small>
          </span>
        </nb-option>
      </nb-select>

      <label class="field-label">
        {{ 'tutor.twinLinks.noteLabel' | translate }}
      </label>
      <textarea
        nbInput
        fullWidth
        rows="2"
        [(ngModel)]="requestNote"
        placeholder="{{ 'tutor.twinLinks.notePlaceholder' | translate }}"
      ></textarea>

      <div class="panel-actions">
        <button nbButton ghost size="small" (click)="toggleRequest()">
          {{ 'buttons.cancel' | translate }}
        </button>
        <button
          nbButton
          status="primary"
          size="small"
          [disabled]="!requestTargetId || loading"
          (click)="submitRequest()"
        >
          {{ 'tutor.twinLinks.sendRequest' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
